import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import notEq from 'ember-truth-helpers/helpers/not-eq';
import Icd10Dropdown from 'parog-web/components/comorbidity/edition-form/icd10-dropdown';
import PathologyDetection from 'parog-web/components/comorbidity/pathology-detection';
import Base from 'parog-web/components/forc/provider/base';
import type Patient from 'parog-web/models/patient';
import { getEnvironmentNameFromHostname } from 'parog-web/utils/runtime-environment';

interface Signature {
  Args: {
    changeset: EmberChangeset;
    patient: Patient;
  };
  Blocks: {
    comorbidityAdditionalInfo: [];
  };
}

export default class ComorbidityEditionFormComponent extends Component<Signature> {
  get shouldDisplayDetection() {
    return getEnvironmentNameFromHostname(window.location.hostname) == 'demo';
  }

  <template>
    <Base @changeset={{@changeset}} as |Form|>
      <div class='field'>
        <Icd10Dropdown
          @form={{Form}}
          @changeset={{@changeset}}
          @patient={{@patient}}
        />
      </div>

      {{#if this.shouldDisplayDetection}}
        <div class='field'>
          <PathologyDetection @changeset={{@changeset}} @patient={{@patient}} />
        </div>
      {{/if}}

      {{#if (notEq @patient.therapeuticalArea.id 'mental')}}
        <div>{{yield to='comorbidityAdditionalInfo'}}</div>
      {{/if}}

      <div class='field'>
        <Form.Input @labelName='Allergies' @propertyName='medicatedAllergies' />
      </div>

      <div class='field'>
        <Form.Input @labelName='Intolérances' @propertyName='intolerences' />
      </div>
    </Base>
  </template>
}
